import { render, staticRenderFns } from "./LicenceEditor.vue?vue&type=template&id=2c9b40a6&scoped=true"
import script from "./LicenceEditor.vue?vue&type=script&lang=js"
export * from "./LicenceEditor.vue?vue&type=script&lang=js"
import style0 from "./LicenceEditor.vue?vue&type=style&index=0&id=2c9b40a6&prod&lang=css"
import style1 from "./LicenceEditor.vue?vue&type=style&index=1&id=2c9b40a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b40a6",
  null
  
)

export default component.exports